import {
  FETCH_CAS_NUMBER,
  FETCH_CAS_NUMBER_SUCCESS,
  FETCH_CAS_NUMBER_FAILURE,
  ADD_CAS_NUMBER_FOR_RESULT_NAME,
  CLEAR_CAS_NUMBERS,
} from '@Containers/CasNumber/constants';
import { getKey } from '@Containers/CasNumber/utils';
import { getStateFromStorage } from '@Containers/CasNumber/persistedState';

export const initialState = {};
export const persistedState = getStateFromStorage() || initialState;

// eslint-disable-next-line default-param-last
export default function reducer(state = persistedState, action) {
  switch (action.type) {
    case FETCH_CAS_NUMBER: {
      const { databaseId, substanceId } = action.payload;
      const key = getKey(databaseId, substanceId);
      return {
        ...state,
        [key]: {
          isLoading: true,
          casNumber: undefined,
          errorNumber: undefined,
        },
      };
    }
    case FETCH_CAS_NUMBER_SUCCESS: {
      const { databaseId, substanceId, casNumber } = action.payload;
      const key = getKey(databaseId, substanceId);
      return {
        ...state,
        [key]: {
          isLoading: false,
          casNumber,
          errorNumber: undefined,
        },
      };
    }
    case FETCH_CAS_NUMBER_FAILURE: {
      const { databaseId, substanceId, errorNumber } = action.payload;
      const key = getKey(databaseId, substanceId);
      return {
        ...state,
        [key]: {
          isLoading: false,
          casNumber: undefined,
          errorNumber,
        },
      };
    }
    case ADD_CAS_NUMBER_FOR_RESULT_NAME: {
      const { resultName, casNumber } = action.payload;
      return {
        ...state,
        [resultName]: {
          casNumber,
        },
      };
    }
    case CLEAR_CAS_NUMBERS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
